<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-checkbox
          v-model="value.parameter1"
          label="Delete Current Row"
          hide-details
        />
      </v-col>
      <v-col cols="12">
        <TablePicker v-model="value.parameter2" title="Data Table" />
      </v-col>
      <v-col cols="12">
        <ServerFilterEditor v-model="value.filters" :table="value.parameter1" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TablePicker from "../../ui/shared/TablePicker.vue";
import ServerFilterEditor from "../../ui/shared/ServerFilterEditor.vue";

export default {
  name: "DeleteRowDesigner",

  components: { TablePicker, ServerFilterEditor },

  props: ["value"],
};
</script>